var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2156 5.24566C24.2384 5.4697 24.2384 5.68828 24.2384 5.92872C24.2384 12.9233 18.6809 20.9998 8.50169 20.9998C5.36919 20.9998 2.46492 20.1309 0 18.6227C0.439349 18.661 0.884408 18.7047 1.32376 18.7047C3.9142 18.7047 6.31065 17.8577 8.20499 16.426C5.78572 16.3877 3.74303 14.8522 3.0298 12.7375C3.36644 12.7976 3.72591 12.8358 4.07967 12.8358C4.58178 12.8358 5.06678 12.7757 5.52895 12.6555C3.00127 12.1692 1.08982 10.0161 1.08982 7.45877V7.37681C1.86581 7.79757 2.71027 8.02161 3.59468 8.04347C2.12257 7.09812 1.13546 5.48609 1.13546 3.62817C1.13546 2.66096 1.40934 1.75385 1.89434 0.966969C4.62743 4.16916 8.68998 6.28937 13.3003 6.50795C13.2147 6.12544 13.1519 5.72107 13.1519 5.3003C13.1519 2.37681 15.634 -0.000244141 18.6866 -0.000244141C20.2842 -0.000244141 21.7164 0.644565 22.7263 1.67189C23.9702 1.43145 25.1684 1.00522 26.2411 0.38227C25.8417 1.63364 24.9573 2.66096 23.8218 3.32216C24.9345 3.18008 26.0072 2.9014 27 2.47517C26.2354 3.55167 25.3054 4.47517 24.2156 5.24566Z",
    fill: "#1C9CEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0f7eeacc28fda269cb36582bae111f95.svg";
export { ForwardRef as ReactComponent };